import React from 'react';
import { cn } from '@/lib/utils';

export const GlassCard = React.forwardRef(({ className, children, hover = true, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'glass-card rounded-2xl p-6',
        hover && 'hover:shadow-2xl hover:-translate-y-1',
        'transition-all duration-300',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

GlassCard.displayName = 'GlassCard';

export const GlassCardDark = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'glass-dark rounded-2xl p-6 text-white',
        'transition-all duration-300',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

GlassCardDark.displayName = 'GlassCardDark';